/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import addressTranslations from "./addressTranslations";
import contactTranslations from "./contactTranslations";
import bankDataTranslations from "./bankDataTranslations";

const personTranslations = {
  gender: {
    label: "Anrede",
    options: {
      male: { label: "Herr" },
      female: { label: "Frau" },
    },
  },
  givenName: {
    label: "Vorname",
  },
  familyName: {
    label: "Nachname",
  },
  nationality: {
    label: "Staatsangehörigkeit",
  },
  birthDate: {
    label: "Geburtsdatum",
    question: "Wann wurden Sie geboren?",
  },
  residenceAddress: addressTranslations,
  addresses: [addressTranslations],
  bankData: bankDataTranslations,
  ...contactTranslations,
};

export default personTranslations;
